import Button from '@mui/joy/Button';
// import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import JoyLink from '@mui/joy/Link';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import { gql, useMutation } from '@apollo/client';
import { useFeedback } from '../feedback/Service';
import { AUTH_TOKEN_NAME } from '../../constants';
import { parseGraphQLError } from '../../utils';
import { useState, useEffect } from 'react';
import GoogleLoginButton from './GoogleLoginButton';
import { Link, useParams } from 'react-router';
// import { isFreeEmailDomain } from '../../utils/freeEmailDomains';
import config from '../../config';
import { Checkbox, FormHelperText, Grid } from '@mui/joy';
import useUser from './useUser';
// import ClientLanding from '../ClientLanding';

const REGISTER = gql`
  mutation Register($user: NewUser!) {
    register(user: $user)
  }
`;


const SignUpForm = () => {
  const [register, { loading }] = useMutation(REGISTER);
  const [password, setPassword] = useState("");
  const [googleCredentials, setGoogleCredentials] = useState(null);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [terms, setTerms] = useState(false);
  const [emailError, setEmailError] = useState("");
  // const [isUsBased, setIsUsBased] = useState(!isTalent);
  const feedback = useFeedback();
  const { refetch: getUser, loading: userLoading } = useUser({ notifyOnNetworkStatusChange: true });
  const { inviteCode, clientId/* , jobId */ } = useParams();

  // const isClientSignup = !clientId && !jobId;

  // Restore prefill data from sessionStorage (when user comes back from ConfirmEmail)
  useEffect(() => {
    const prefillData = sessionStorage.getItem('signup_prefill');
    if (prefillData) {
      try {
        const { firstName: savedFirstName, lastName: savedLastName } = JSON.parse(prefillData);
        if (savedFirstName) setFirstName(savedFirstName);
        if (savedLastName) setLastName(savedLastName);
        setTerms(true);
        sessionStorage.removeItem('signup_prefill');
      } catch (e) {
        console.warn('Failed to parse signup prefill data', e);
        sessionStorage.removeItem('signup_prefill');
      }
    }
  }, []);

  // Check for stored invite code (from previous signup attempt)
  const storedInviteCode = sessionStorage.getItem('signup_invite_code');
  const effectiveInviteCode = inviteCode || storedInviteCode;
  console.log("Codes", { inviteCode, storedInviteCode, effectiveInviteCode });

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate email domain for client/company signups
    // if (isClientSignup && isFreeEmailDomain(email)) {
    //   setEmailError("Please use your company email address. Free email providers are not allowed for business accounts.");
    //   return;
    // }
    setEmailError("");

    let leadType = new URLSearchParams(window.location.search).get('lt');
    if (!leadType && clientId)
      leadType = "-";
    const data = new FormData(event.currentTarget);
    const user = {
      email,
      password: data.get('password'),
      firstName,
      lastName,
      newsletter: !!data.get('allowExtraEmails'),
      googleCredentials,
      leadType
    };
    try {
      const { data: { register: token } } = await register(({ variables: { user } }));
      const tagPrefix = window.location.pathname.startsWith("/company") ? "talent_" : "client_";
      window.gtag('event', tagPrefix + 'register', {});
      localStorage.setItem(AUTH_TOKEN_NAME, token);
      // Save invite code for potential use in ConfirmEmail cancel flow
      if (inviteCode) {
        sessionStorage.setItem('signup_invite_code', inviteCode);
      }
      console.log(token);
      getUser({ fetchPolicy: 'network-only' });
    } catch (error) {
      console.warn("Register error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  };

  const handleGoogleLogin = async (credentials) => {
    if (!credentials.clientId)
      credentials.clientId = config.googleClientId;

    const { email, family_name, given_name } = await fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=${credentials.credential}`).then(res => res.json());

    // Validate email domain for client/company signups
    // if (isClientSignup && isFreeEmailDomain(email)) {
    //   setEmailError("Please use your company email address. Free email providers are not allowed for business accounts.");
    //   feedback.snackbar({ text: "Please use your company email address to sign up.", type: "error" });
    //   return;
    // }

    setGoogleCredentials(credentials);
    setEmail(email);
    setFirstName(given_name);
    setLastName(family_name);
  }

  // useEffect(() => {
  //   if (googleCredentials && email && firstName && lastName) {
  //     handleSubmit();
  //   }
  // }, [googleCredentials, email, firstName, lastName]);

  // if (!clientId && !jobId && effectiveInviteCode?.toLowerCase() !== "tony")
  //   return <ClientLanding />;

  return (
    <Box
      component="main"
      sx={{
        my: 'auto',
        py: 2,
        pb: 5,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: 400,
        maxWidth: '100%',
        mx: 'auto',
        borderRadius: 'sm',
        '& form': {
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        },
        // [`& .MuiFormLabel-asterisk`]: {
        //   visibility: 'hidden',
        // },
      }}
    >
      <Stack sx={{ gap: 4, mb: 2 }}>
        <Stack sx={{ gap: 1 }}>
          <Typography component="h1" level="h3">
            Sign up
          </Typography>
          <Typography level="body-sm">
            Already have an account?{' '}
            <JoyLink level="title-sm" component={Link} to="../sign-in">
              Sign in
            </JoyLink>
          </Typography>
        </Stack>
        {(!googleCredentials && config.enableGoogleLogin) &&
          <GoogleLoginButton onSuccess={handleGoogleLogin} />
        }
      </Stack>
      <Divider
        sx={(theme) => ({
          [theme.getColorSchemeSelector('light')]: {
            color: { xs: '#FFF', md: 'text.tertiary' },
          },
        })}
      >
        or
      </Divider>
      <Stack sx={{ gap: 4, mt: 2 }}>
        <form
          onSubmit={handleSubmit}
        >
          <Grid container spacing={2}>
            <Grid xs={12} sm={6}>
              <FormControl required>
                <FormLabel>First name</FormLabel>
                <Input name="firstName" value={firstName} onChange={e => setFirstName(e.target.value)} />
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6}>
              <FormControl required>
                <FormLabel>Last name</FormLabel>
                <Input name="lastName" value={lastName} onChange={e => setLastName(e.target.value)} />
              </FormControl>
            </Grid>
          </Grid>
          <FormControl required error={!!emailError}>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              name="email"
              value={email}
              onChange={e => {
                setEmail(e.target.value);
                if (emailError) setEmailError("");
              }}
              disabled={!!googleCredentials}
            />
            {emailError && <FormHelperText>{emailError}</FormHelperText>}
          </FormControl>
          {!googleCredentials &&
            <FormControl required>
              <FormLabel>Password</FormLabel>
              <Input type="password" name="password" value={password} onChange={e => setPassword(e.target.value)} />
            </FormControl>
          }
          {/* {isTalent &&
            <Checkbox
              label={"Are you legally authorized to work in the United States?"}
              checked={isUsBased}
              onChange={(e) => setIsUsBased(e.target.checked)}
              required
              size='sm'
            />
          } */}
          <FormControl required size="sm">
            <Checkbox
              label={<>
                By signing up you agree to our Terms of Service and Privacy Policy.
              </>}
              checked={terms}
              onChange={(e) => setTerms(e.target.checked)}
            />
            <FormHelperText>
              <Typography level="body-sm">
                Read our <JoyLink href="https://www.cavalryhr.com/terms-of-service" target="_blank">Terms of Service</JoyLink> and <JoyLink href="https://www.cavalryhr.com/privacy-policy" target="_blank">Privacy Policy</JoyLink>.
              </Typography>
            </FormHelperText>
          </FormControl>
          <Stack sx={{ gap: 4, mt: 2 }}>
            <Button type="submit" fullWidth loading={loading || userLoading}>
              Sign up
            </Button>
          </Stack>
        </form>
      </Stack>
    </Box>
  );
}

export default SignUpForm;